import React from 'react';
import {
  RangeBlock, RangeCaption, RangeInputsRow, RangeField, RangeFieldLabel, RangeInput, RangeSeparator,
} from '../inventory.styles';

// Edycja zakresu liczbowego bez natychmiastowego filtrowania w trakcie wpisywania.
// Wartości trafiają do filtra 350 ms po ostatnim znaku albo od razu po Enter.
//
// Układ (25.10.2026): „od” i „do” stoją obok siebie, każde z krótkim podpisem nad polem, a nad
// nimi podpis całego zakresu. Wcześniej pola stały jedno pod drugim z gołym „-” pomiędzy i
// sklejały się z wyszukiwarką rozmiarów poniżej, więc zakres czytał się jak trzy pola listy.
function InlineRangeEditor({
  minValue, maxValue, onApply, caption, labelMin, labelMax, placeholderMin, placeholderMax,
}) {
  const [localMin, setLocalMin] = React.useState(minValue ?? '');
  const [localMax, setLocalMax] = React.useState(maxValue ?? '');
  const id = React.useId();

  React.useEffect(() => setLocalMin(minValue ?? ''), [minValue]);
  React.useEffect(() => setLocalMax(maxValue ?? ''), [maxValue]);

  React.useEffect(() => {
    const t = setTimeout(() => {
      onApply({ min: localMin, max: localMax });
    }, 350);
    return () => clearTimeout(t);
  }, [localMin, localMax, onApply]);

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onApply({ min: localMin, max: localMax });
      e.preventDefault();
    }
  };

  const pole = (suffix, label, placeholder, value, setValue) => (
    <RangeField>
      <RangeFieldLabel htmlFor={`${id}-${suffix}`}>{label}</RangeFieldLabel>
      <RangeInput
        id={`${id}-${suffix}`}
        type="number"
        inputMode="decimal"
        step="0.5"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        onWheel={(e) => e.currentTarget.blur()}
        data-cy={`size-range-${suffix}`}
      />
    </RangeField>
  );

  return (
    <RangeBlock role="group" aria-labelledby={caption ? `${id}-caption` : undefined}>
      {caption && <RangeCaption id={`${id}-caption`}>{caption}</RangeCaption>}
      <RangeInputsRow>
        {pole('min', labelMin, placeholderMin, localMin, setLocalMin)}
        <RangeSeparator aria-hidden="true">–</RangeSeparator>
        {pole('max', labelMax, placeholderMax, localMax, setLocalMax)}
      </RangeInputsRow>
    </RangeBlock>
  );
}

export default InlineRangeEditor;
